import { useQueryString } from 'hooks/useQueryString';

export const useScrollToQueryParameter = () => useQueryString('scrollTo');
